module.exports = __webpack_public_path__ + "assets/img/development.3eba9867.png";